import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import compose from 'recompose/compose'

import Element from '@/ui/Element'
import Button from '@/ui/Button/Button'
import Card from '@/ui/Card/Card'
import InputField from '@/ui/Input/InputField'

import LogoTitle from '../../media/el-logo.png'

import translate from '@/i18n/translate'
import { userLogin as userLoginAction } from '@/state/actions/auth'
import { routeLogin } from '@/state/actions/routes'

const renderInput = ({ meta: { touched, error } = {}, input: { ...inputProps }, ...props }) => (
  <InputField errorText={touched && error} {...inputProps} {...props} fullWidth />
)

const Login = props => {
  const login = ({ username, password }) => {
    const { userLogin } = props
    userLogin({ username, password })
  }
  const { handleSubmit, submitting, theme } = props

  return (
    <Element classes={['flex-center']} theme={theme}>
      <Element classes="login-box" theme={theme}>
        <Card header={<img src={LogoTitle} alt="" />} theme={theme} classes="card-dark-header">
          <form onSubmit={handleSubmit(login)} className={theme['form']}>
            <div>
              <Field
                name="usernameforgot"
                labelText="E-mail:"
                component={renderInput}
                style={{ width: '100%' }}
                placeholder="you@elovade.com"
                id="usernameforgot"
              />
            </div>
            <Button
              theme={theme}
              type="submit"
              classes={['success', 'block']}
              disabled={submitting}
            >
              Reset your password
            </Button>
          </form>
        </Card>
        <div className={theme['text-center']}>
          <Button
            theme={theme}
            styles="forgot-button"
            classes="clean"
            onClick={() => props.dispatch(routeLogin())}
          >
            Back to login
          </Button>
        </div>
      </Element>
    </Element>
  )
}

const enhance = compose(
  connect(null, { userLogin: userLoginAction }),
  translate,
  reduxForm({
    form: 'reset',
    validate: (values, props) => {
      const errors = {}
      const { translate } = props
      if (!values.usernameforgot) errors.usernameforgot = translate('i18n.validation.required')
      return errors
    },
  }),
)

export default enhance(Login)



// WEBPACK FOOTER //
// ./view/Login/Reset.js